module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<dl class=\'stepped zero\'>\n    <form>\n        <dt>\n            <label for=\'actuators\'>Actuators</label>\n        </dt>\n        <dd>\n            <select class=\'text\' id=\'actuators\' name=\'actuators\'></select>\n        </dd>\n    </form>\n</dl>\n';

}
return __p
}